import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiagnosticToolComponent } from './components/diagnostic-tool/diagnostic-tool.component';
import { UserTypeComponent } from './components/user-type/user-type.component';
import { OfferMiniatureComponent } from './components/offer-miniature/offer-miniature.component';
import { HomeComponent } from './home.component';
import { DsrIconsModule } from '@desyre/icons-angular';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgRenaultFeedbackModule } from 'ng-renault-feedback';
import { ChatbotModule } from '../chatbot/chatbot.module';

@NgModule({
  declarations: [
    HomeComponent,
    OfferMiniatureComponent,
    UserTypeComponent,
    DiagnosticToolComponent
  ],
  imports: [
    CommonModule,
    DsrIconsModule,
    RouterModule,
    TranslateModule,
    NgRenaultFeedbackModule,
    ChatbotModule
  ]
})

export class HomeModule { }